import { render, staticRenderFns } from "./CommissionSchema.vue?vue&type=template&id=521bc36c&"
import script from "./CommissionSchema.vue?vue&type=script&setup=true&lang=js&"
export * from "./CommissionSchema.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports